module.exports = __webpack_public_path__ + "c27a17ec3f4e07d5815172e387dcd5f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-photo/img/small_170x170_noicon.png
// module id = 750
// module chunks = 0